import React, { useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import '../../assets/css/layout/ngo/NgoSidebar.css';

const NgoSidebar = () => {
  const location = useLocation();
  const activeItemRef = useRef(null);
  const navRef = useRef(null);

  const menuItems = [
    { path: '/ngo/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/ngo/Allcases', icon: '👨‍🎓', label: 'All-Cases' },
    // { path: '/ngo/approvedcases', icon: '👩‍✈️', label: 'ApprovedCases' },
    // { path: '/ngo/donationtracking', icon: '📋', label: 'Donation-Tracking' },
    // { path: '/ngo/ngofund', icon: '📋', label: 'NgoFund' },
    { path: '/ngo/funddistribution', icon: '📄', label: 'Donation Tracking' },
    { path: '/ngo/payout', icon: '💳', label: 'payout' },
    { path: '/ngo/disputes', icon: '⚠️', label: 'Disputes', noScroll: true },
    { path: '/ngo/donorlevels', icon: '🏆', label: 'Donor-Reward&Levels', noScroll: true },
  ];

  // Scroll active item into view when location changes
  useEffect(() => {
    // Small delay to ensure DOM is updated
    const timer = setTimeout(() => {
      if (activeItemRef.current && navRef.current) {
        const navElement = navRef.current;
        const activeElement = activeItemRef.current;
        
        // Check if current item has noScroll flag
        const currentItem = menuItems.find(item => item.path === location.pathname);
        if (currentItem?.noScroll) {
          return; // Don't scroll for last two items
        }
        
        // Get positions
        const navRect = navElement.getBoundingClientRect();
        const activeRect = activeElement.getBoundingClientRect();
        
        // Calculate if active item is out of view
        const isAboveView = activeRect.top < navRect.top;
        const isBelowView = activeRect.bottom > navRect.bottom;
        
        if (isAboveView || isBelowView) {
          // Scroll the active item into view with smooth behavior
          activeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div className="ngo-sidebar">
      <div className="ngo-sidebar-header">
        <div className="ngo-logo-container">
          <div className="ngo-logo-icon">🎓</div>
          <h3 className="ngo-logo-text">NGO Support Hub</h3>
        </div>
      </div>

      <nav className="ngo-sidebar-nav" ref={navRef}>
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              isActive ? 'ngo-nav-item ngo-nav-active' : 'ngo-nav-item'
            }
            innerRef={(el) => {
              if (location.pathname === item.path) {
                activeItemRef.current = el;
              }
            }}
          >
            <span className="ngo-nav-icon">{item.icon}</span>
            <span className="ngo-nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="ngo-sidebar-footer">
        <button className="ngo-logout-btn">
          <span className="ngo-logout-icon">🚪</span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default NgoSidebar;